module.exports = "<symbol id=\"tt-icon-caret-right\" viewBox=\"0 0 24 24\"><path d=\"M14.06 12l-8.92 9.43L7.54 24l11.32-12L7.54 0l-2.4 2.57L14.06 12z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/VuTUYdwvqIExdDFsite/assets/svg/non-defined-page/caret-right.svg
// module id = 160
// module chunks = 11